import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../css/Navbar.css';
import logo from '../img/logos/RM_banner_transparent.png';

const Navbar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const totalScroll = docHeight - windowHeight;
      const progress = (scrollTop / totalScroll) * 100;
      setScrollProgress(progress);
      setIsScrolled(scrollTop > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleSectionScroll = (sectionId, offset = -40) => {
    closeMobileMenu();
    
    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/', {
        state: { scrollTo: sectionId, scrollOffset: offset }
      });
    } else {
      // We're already on homepage, scroll to section
      scrollToSection(sectionId, offset);
    }
  };

  const scrollToSection = (sectionId, offset) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Check for scroll target after navigation
  useEffect(() => {
    if (location.state?.scrollTo) {
      // Small timeout to ensure page is loaded before scrolling
      const timer = setTimeout(() => {
        scrollToSection(location.state.scrollTo, location.state.scrollOffset || -40);
        // Clear the state to prevent re-scrolling
        window.history.replaceState({}, document.title);
      }, 50);
      
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <>
      <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }}></div>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
          <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className="navbar-logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="logo" />
          </Link>
        </div>

        <div className={`navbar-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/services" onClick={closeMobileMenu}>Services</Link></li>
            <li>
              <button 
                className="nav-link-button" 
                onClick={() => handleSectionScroll('results', -250)}
              >
                Results
              </button>
            </li>
            <li>
              <button 
                className="nav-link-button" 
                onClick={() => handleSectionScroll('whyromulus')}
              >
                Why Romulus
              </button>
            </li>
            <li><Link to="/about" onClick={closeMobileMenu}>About</Link></li>
          </ul>
        </div>

        <div className="navbar-actions">
          <Link to="/brands" onClick={closeMobileMenu}>
            <button className="get-started-btn">Start A Program</button>
          </Link>
          <Link to="/creator" onClick={closeMobileMenu}>
            <button className="get-started-btn create-with-us-btn">Create with Us</button>
          </Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;